var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 83 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.214 75.088a14.67 14.67 0 01-6.543-9.407 126.661 126.661 0 01-.054-51.487c.399-1.914 1.18-3.728 2.295-5.334a15.3 15.3 0 019.777-6.287 142.356 142.356 0 0153.555-.063l-.006.015a15.662 15.662 0 015.558 2.197 14.727 14.727 0 016.537 9.414 126.757 126.757 0 01.052 51.482 14.49 14.49 0 01-2.294 5.334 15.323 15.323 0 01-9.786 6.288 142.387 142.387 0 01-53.546.056 15.633 15.633 0 01-5.545-2.208z",
    fill: "#C2E9FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#00A1DC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 23,
    y: 24,
    width: 38,
    height: 32,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A1DC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M32 18v10M24 35h36M52 18v10"
  }))));
}
export default SvgCalendar;